var map = {
	"./file-extension/7zip.svg": 22701,
	"./file-extension/ace.svg": 52756,
	"./file-extension/aep.svg": 87618,
	"./file-extension/aepx.svg": 49488,
	"./file-extension/aet.svg": 16406,
	"./file-extension/ai.svg": 17191,
	"./file-extension/ait.svg": 78442,
	"./file-extension/avi.svg": 5587,
	"./file-extension/bmp.svg": 43135,
	"./file-extension/c.svg": 13349,
	"./file-extension/css.svg": 24909,
	"./file-extension/default.svg": 33181,
	"./file-extension/doc.svg": 5880,
	"./file-extension/docx.svg": 24543,
	"./file-extension/dotx.svg": 3883,
	"./file-extension/eps.svg": 65260,
	"./file-extension/flv.svg": 49023,
	"./file-extension/folder.svg": 54129,
	"./file-extension/gif.svg": 88927,
	"./file-extension/html.svg": 8474,
	"./file-extension/java.svg": 9683,
	"./file-extension/jpeg.svg": 17020,
	"./file-extension/jpg.svg": 94223,
	"./file-extension/js.svg": 68459,
	"./file-extension/less.svg": 6303,
	"./file-extension/m4a.svg": 11834,
	"./file-extension/mid.svg": 65793,
	"./file-extension/mp3.svg": 92756,
	"./file-extension/mp4.svg": 18581,
	"./file-extension/mpg.svg": 97003,
	"./file-extension/odf.svg": 98932,
	"./file-extension/ods.svg": 78028,
	"./file-extension/odt.svg": 60659,
	"./file-extension/otp.svg": 64722,
	"./file-extension/ots.svg": 87460,
	"./file-extension/ott.svg": 95388,
	"./file-extension/pdf.svg": 24385,
	"./file-extension/php.svg": 47017,
	"./file-extension/png.svg": 65703,
	"./file-extension/ppt.svg": 54560,
	"./file-extension/pptx.svg": 10151,
	"./file-extension/psd.svg": 44709,
	"./file-extension/py.svg": 94405,
	"./file-extension/qt.svg": 54350,
	"./file-extension/rar.svg": 65199,
	"./file-extension/raw.svg": 96751,
	"./file-extension/svg.svg": 19029,
	"./file-extension/tga.svg": 82934,
	"./file-extension/tgz.svg": 8671,
	"./file-extension/txt.svg": 1886,
	"./file-extension/wav.svg": 92068,
	"./file-extension/xls.svg": 86043,
	"./file-extension/xlsx.svg": 16640,
	"./file-extension/xml.svg": 44690,
	"./file-extension/zip.svg": 98344,
	"./font-awesome/angle-right-regular.svg": 31894,
	"./font-awesome/arrow-to-bottom-light.svg": 84419,
	"./font-awesome/bars-regular.svg": 3530,
	"./font-awesome/bell-regular.svg": 4830,
	"./font-awesome/check-circle-light.svg": 47877,
	"./font-awesome/check-circle-solid.svg": 69040,
	"./font-awesome/chevron-down-solid.svg": 53263,
	"./font-awesome/chevron-left-regular.svg": 85340,
	"./font-awesome/chevron-right-solid.svg": 2117,
	"./font-awesome/circle-solid.svg": 76278,
	"./font-awesome/cloud-upload-light.svg": 73459,
	"./font-awesome/cog-duotone.svg": 14173,
	"./font-awesome/cog-regular.svg": 35575,
	"./font-awesome/comments-alt-regular.svg": 50300,
	"./font-awesome/envelope-solid.svg": 89084,
	"./font-awesome/exclamation-triangle-duotone.svg": 72850,
	"./font-awesome/exclamation-triangle-light.svg": 23243,
	"./font-awesome/eye-dropper-solid.svg": 67115,
	"./font-awesome/filter-regular.svg": 64346,
	"./font-awesome/fingerprint-duotone.svg": 96351,
	"./font-awesome/id-card-duotone.svg": 74265,
	"./font-awesome/id-card-regular.svg": 15861,
	"./font-awesome/inbox-out-duotone.svg": 77615,
	"./font-awesome/inbox-regular.svg": 22207,
	"./font-awesome/info-circle-light.svg": 83266,
	"./font-awesome/keyboard-duotone.svg": 17490,
	"./font-awesome/language-duotone.svg": 61492,
	"./font-awesome/language-regular.svg": 72659,
	"./font-awesome/lock-alt-regular.svg": 20861,
	"./font-awesome/lock-open-alt-solid.svg": 11494,
	"./font-awesome/pennant-regular.svg": 64349,
	"./font-awesome/reply-regular.svg": 55707,
	"./font-awesome/robot-duotone.svg": 77812,
	"./font-awesome/search-duotone.svg": 8807,
	"./font-awesome/search-regular.svg": 59076,
	"./font-awesome/share-alt-solid.svg": 92409,
	"./font-awesome/sort-amount-down-alt-regular.svg": 46900,
	"./font-awesome/sort-amount-up-alt-regular.svg": 17350,
	"./font-awesome/swatchbook-duotone.svg": 61585,
	"./font-awesome/sync-regular.svg": 33557,
	"./font-awesome/tachometer-alt-regular.svg": 95774,
	"./font-awesome/tags-regular.svg": 21341,
	"./font-awesome/tasks-regular.svg": 35871,
	"./font-awesome/times-circle-light.svg": 37797,
	"./font-awesome/times-circle-solid.svg": 78209,
	"./font-awesome/times-light.svg": 96606,
	"./font-awesome/times-solid.svg": 25275,
	"./font-awesome/trash-alt-regular.svg": 31055,
	"./font-awesome/user-tag-regular.svg": 52347,
	"./font-awesome/users-class-regular.svg": 12772,
	"./font-awesome/users-duotone.svg": 55202,
	"./font-awesome/users-regular.svg": 61195,
	"./undraw/browsing.svg": 31228,
	"./undraw/page-not-found.svg": 37911,
	"./undraw/task-list.svg": 26484
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80619;